import { useState, useEffect, useContext, useMemo, useRef, forwardRef, useImperativeHandle } from "react";
import styles from './index.module.scss'
import PicModalLeft from './PicModalLeft'
import PicModalMiddle from './PicModalMiddle'
import PicModalRight from './PicModalRight'
import PicModalFooter from './PicModalFooter'


const PictureViewModal = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
    }))
    const { groupedTasks, isModalOpen, setIsModalOpen, item, setItem, taskId, setTaskId, modalOpenFlag, displayType } = props
    const [selectedInputImg, setSelectedInputImg] = useState()
    const [currentViewIsHD, setCurrentViewIsHD] = useState(false)

    const onCancel = () => {
        setTaskId()
        setItem()
        setSelectedInputImg()
        setCurrentViewIsHD(false)
        setIsModalOpen(false)
        setCurrentIndex(null)
    }

    const [currentIndex, setCurrentIndex] = useState(null)

    useEffect(() => {
        if (!taskId || groupedTasks.length == 0) {
            onCancel()
            return
        }

        const flatTasks = groupedTasks?.flat()?.filter(task => task.status === 'succeeded')

        const index = flatTasks.findIndex(t => t.taskId === taskId)

        if (index !== -1) {
            // 找到当前项
            setCurrentIndex(index)
            const newItem = flatTasks[index]
            if (JSON.stringify(newItem) !== JSON.stringify(item)) {
                setItem(newItem)
            }
        } else {
            // 删除后，找不到 taskId 对应项
            const total = flatTasks.length
            if (total === 0) {
                setIsModalOpen(false)
                return;
            }

            let newIndex = null;
            if (currentIndex !== null) {
                if (currentIndex >= flatTasks.length) {
                    // 如果删的是最后一项，则取第一项
                    newIndex = 0;
                } else {
                    //即删除项的下一项
                    newIndex = currentIndex;
                }
            }

            const item = flatTasks[newIndex]
            setCurrentIndex(newIndex)
            setItem(item)
            setTaskId(item?.taskId)
        }
    }, [groupedTasks, taskId])

    useEffect(() => {
        if (!item) return
        setSelectedInputImg(item?.inputImage?.split(",")?.[0])
        setCurrentViewIsHD(item?.results?.[0]?.hdImage ? true : false)
    }, [item])

    useEffect(() => {
        if (!isModalOpen) {
            setItem()
            setTaskId()
            setSelectedInputImg()
        }
    }, [isModalOpen])

    useEffect(() => {
        if (!taskId || !item || !selectedInputImg) return
        setIsModalOpen(true)
    }, [taskId, item, selectedInputImg])

    return (
        <div className={styles.PictureViewModal}>
            <div className={styles.modalContent}>
                <PicModalLeft
                    item={item}
                    fetchProjectDetail={props.fetchProjectDetail}
                    selectedInputImg={selectedInputImg}
                    setSelectedInputImg={setSelectedInputImg} />
                {
                    modalOpenFlag && <>
                        <PicModalMiddle
                            item={item}
                            setProjectId={props.setProjectId}
                            displayType={displayType}
                            rawTasks={groupedTasks?.flat()}
                            currentViewIsHD={currentViewIsHD}
                            fetchProjectDetail={props.fetchProjectDetail}
                            selectedInputImg={selectedInputImg} />
                        <PicModalRight
                            taskId={taskId}
                            setTaskId={setTaskId}
                            groupedTasks={groupedTasks} />
                    </>
                }
            </div>
            <PicModalFooter
                item={item}
                fetchProjectDetail={props.fetchProjectDetail}
                currentViewIsHD={currentViewIsHD}
                setCurrentViewIsHD={setCurrentViewIsHD}
            />
        </div>

    )
})

export default PictureViewModal